export enum MaintenancePerformReferrer {
  CorrectiveActionEdit = 'correctiveActionEdit',
}
